<template>
  <div class="aboutpage container-fluid">
    <img class="about-header" src="\img\aboutus.webp" alt="" /> <PdkHeader />
    <svg
      class="curved-shape"
      fill="#f5f7f9"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      viewBox="0 0 1500 103.06"
      style="enable-background: new 0 0 1500 103.06"
      xml:space="preserve"
    >
      <path
        class="st0"
        d="M0,103.06h1500c0,0,0-90.59-101.4-92.01c-91.07-1.28-546.33,0.36-681.51,0.36  c-127.36,0-507.58-0.32-618.77-0.36C0,11,0,103.06,0,103.06z"
      />
    </svg>
    <div class="aboutbody">
       
        <div class="row">
        <div class="col-md-7 about-title">
                    
            <h2 >سامانه مدرن گردشگری داریوش </h2>
            <p>
                بطور خلاصه این شرکت دارای زیرمجموعه‌های گسترده‌ای است که تلاش کرده‌ایم در یک تیم منظم و یکپارچه و با مدیریت بهینه، همزمان با ایجاد بسترهای مناسب در تولید و عرضه‌ی خدمات مناسب و استاندارد به جامعه‌ی بزرگ میهمانان گرامی خود، در رفع نیاز همکاران خود در دیگر بخش‌های گردشگری و توسعه‌ی مشارکت محور در این صنعت نقش آفرین باشیم.
            </p>
        </div>
        <div class="col-md-5">
                <img src="\img\dhuio.webp" alt="">
        </div>
           <hr  style="margin-bottom: 45px; width:100%"/>
        <div class="col-12 about-center">
            <p>
                این مجموعه در سال 2016 و با هدف ایجاد یک سامانه مدرن گردشگری زیرمجموعه هتل بزرگ داریوش کیش تاسیس گردید ولی به تدریج و با توسعه‌ی موفق کسب و کار تبدیل به بال گردشگری هلدینگ بزرگ زاگرس گردیده‌است. هلدینگ بزرگ زاگرس دارای یک بال در صنعت هوانوردی است که شامل هواپیمایی زاگرس، شرکت خدمات فرودگاهی همراه کوشا، موتورشاپ ( تعمیر موتور هواپیما )، کیترینگ هوایی زاگرس و چند شرکت فعال دیگر در صنعت هوانوردی است. بال دیگر هلدینگ بزرگ زاگرس در صنعت گردشگری است که شرکت پردیس داریوش کیش ماموریت توسعه‌ی کسب و کارهای مرتبط با آن را دارد. 
            </p>
            <p>
                این مجموعه با رویکردی نوین در راستای ارائه راه‌حلی جامع، مبتنی ‌بر فناوری‌های روز دنیا جهت پاسخگویی به نیازهای بازار گردشگری ایران توسط شرکت ایرسا راه‌اندازی شده است. جهت بررسی و مقایسه و خرید محصول سفر در اختیار مسافران قرار دهد.
            </p>

        </div>

            <div class="col-sm-4">
   <img src="\img\dhuio.webp" alt="">
            </div>
                        <div class="col-sm-8">
                          <h2> تیم طراحی حرفه ای</h2>
                  <p>
                    لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها و شرایط سخت تایپ به پایان رسد وزمان مورد نیاز شامل حروفچینی دستاوردهای اصلی و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.
                  </p>
            </div>
  

      </div>
      <div class="row feature_home_2">
                    <div class="col-md-4 text-center">
                        <img src="img/adventure_icon_1.svg" alt="" width="75" height="75">
                        <h3>Itineraries studied in detail</h3>
                        <p>Suscipit invenire petentium per in. Ne magna assueverit vel. Vix movet perfecto facilisis in, ius ad maiorum corrumpit, his esse docendi in.</p>
                    </div>
                    <div class="col-md-4 text-center">
                        <img src="img/adventure_icon_2.svg" alt="" width="75" height="75">
                        <h3>Room and food included</h3>
                        <p> Cum accusam voluptatibus at, et eum fuisset sententiae. Postulant tractatos ius an, in vis fabulas percipitur, est audiam phaedrum electram ex.</p>
                    </div>
                    <div class="col-md-4 text-center">
                        <img src="img/adventure_icon_3.svg" alt="" width="75" height="75">
                        <h3>Everything organized</h3>
                        <p>Integre vivendo percipitur eam in, graece suavitate cu vel. Per inani persius accumsan no. An case duis option est, pro ad fastidii contentiones.</p>
                    </div>
                </div>
   <section class="promo_full">
			<div class="promo_full_wp magnific">
				<div>
					<h3>BELONG ANYWHERE</h3>
					<p>
						Lorem ipsum dolor sit amet, vix erat audiam ei. Cum doctus civibus efficiantur in. Nec id tempor imperdiet deterruisset, doctus volumus explicari qui ex.
					</p>
					<a href="https://www.youtube.com/watch?v=Zz5cu72Gv5Y" class="video"><i class="icon-play-circled2-1"></i></a>
				</div>
			</div>
		</section>
    <div class="row small-gutters categories_grid">
                <div class="col-sm-12 col-md-6">
                    <a href="all_tours_list.html">
                        <img src="img/img_cat_home_1.jpg" alt="" class="img-fluid">
                        <div class="wrapper">
                            <h2>Special Offers</h2>
                            <p>1150 Locations</p>
                        </div>
                    </a>
                </div>
                <div class="col-sm-12 col-md-6">
                    <div class="row small-gutters mt-md-0 mt-sm-2">
                        <div class="col-sm-6">
                            <a href="all_tours_list.html">
                                <img src="img/img_cat_home_2.jpg" alt="" class="img-fluid">
                                <div class="wrapper">
                                    <h2>Tours</h2>
                                    <p>800 Locations</p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6">
                            <a href="all_hotels_list.html">
                                <img src="img/img_cat_home_3.jpg" alt="" class="img-fluid">
                                <div class="wrapper">
                                    <h2>Hotels</h2>
                                    <p>650 Locations</p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-12 mt-sm-2">
                            <a href="all_restaurants_list.html">
                                <img src="img/img_cat_home_4.jpg" alt="" class="img-fluid">
                                <div class="wrapper">
                                    <h2>Restaurants</h2>
                                    <p>1132 Locations</p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
    </div>
    <PdkFooter />
  </div>
</template>

<script>
import PdkHeader from "@/components/PdkHeader";
import PdkFooter from "@/components/PdkFooter";
export default {
  name: "AboutUs",
  components: {
    PdkHeader,
    PdkFooter,
  },
};
</script>

<style lang="scss">
.aboutpage {
  padding-right: 0 !important;
  padding-left: 0 !important;
  .about-header {
    width: 100%;
  }
  .about-title 
  {
    h2{
    margin: 40px 10px;
  }
  p{
    font-size: 17px ;
    text-align: justify;
  }
}
  .curved-shape {
    margin-top: -130px;
  }
  .aboutbody {
    padding: 2% 5%;
    margin-top: -130px;
    .main_title {
      margin-bottom: 30px;
      &:after {
        width: 30px;
        height: 80px;
        right: -60px;
      }
      content: " ";
    }
    i {
      font-size: 20px;
      color: #bfa56b;
      vertical-align: sub;
      margin-left: 5px;
    }
    .about-center{
        // background-image: url("/img/Expats165420.webp");
        // background-repeat: no-repeat;
        // background-size: cover;
    }
    
  }
}
</style>